import styled from "styled-components";
import heroBackground from "../assets/images/hero_bg_2.jpg";
import { designTokens } from "../theme/designTokens";

/* Page Header Container - Hero Section */
export const PageHeaderContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url(${heroBackground});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  height: 45vh;
  z-index: 1;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 0;
    pointer-events: none;
  }

  @media (max-width: ${designTokens.breakpoints.tablet}) {
    height: 35vh;
  }

  @media (max-width: ${designTokens.breakpoints.mobile}) {
    height: 25vh;
  }
`;

export const PageHeaderOverlay = styled.div`
  background-color: transparent;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
`;

/* Primary Heading - H1 (Page Titles) */
export const HeadingPrimary = styled.h1`
  font-family: ${designTokens.typography.fontFamily.primary};
  font-weight: ${designTokens.typography.fontSize.h1.weight};
  font-size: ${designTokens.typography.fontSize.h1.desktop};
  line-height: ${designTokens.typography.fontSize.h1.lineHeight};
  color: ${(props) => props.fontColor || designTokens.colors.neutral.white};
  margin: ${(props) => props.margin || designTokens.spacing.lg}px 0;
  transition: transform ${designTokens.transitions.smooth};
  z-index: 3;
  letter-spacing: 0.5px;

  @media (max-width: ${designTokens.breakpoints.tablet}) {
    font-size: ${designTokens.typography.fontSize.h1.tablet};
  }

  @media (max-width: ${designTokens.breakpoints.mobile}) {
    font-size: ${designTokens.typography.fontSize.h1.mobile};
  }
`;

/* Secondary Heading - H2 (Section Headings) */
export const HeadingSecondary = styled.h2`
  font-family: ${designTokens.typography.fontFamily.primary};
  font-weight: ${designTokens.typography.fontSize.h2.weight};
  font-size: ${designTokens.typography.fontSize.h2.desktop};
  line-height: ${designTokens.typography.fontSize.h2.lineHeight};
  color: ${(props) => props.fontColor || designTokens.colors.primary.main};
  margin: ${(props) => props.margin || designTokens.spacing.lg}px 0
    ${designTokens.spacing.md}px 0;
  transition: transform ${designTokens.transitions.smooth};
  z-index: ${designTokens.zIndex.base};
  letter-spacing: 0.3px;

  @media (max-width: ${designTokens.breakpoints.tablet}) {
    font-size: ${designTokens.typography.fontSize.h2.tablet};
  }

  @media (max-width: ${designTokens.breakpoints.mobile}) {
    font-size: ${designTokens.typography.fontSize.h2.mobile};
  }
`;

/* Tertiary Heading - H3 (Card/Subsection Titles) */
export const HeadingTertiary = styled.h3`
  font-family: ${designTokens.typography.fontFamily.primary};
  font-weight: ${designTokens.typography.fontSize.h3.weight};
  font-size: ${designTokens.typography.fontSize.h3.desktop};
  line-height: ${designTokens.typography.fontSize.h3.lineHeight};
  color: ${(props) => props.fontColor || designTokens.colors.neutral.darker};
  margin: ${(props) => props.margin || designTokens.spacing.md}px 0
    ${designTokens.spacing.sm}px 0;
  transition: transform ${designTokens.transitions.smooth};
  z-index: ${designTokens.zIndex.base};
  letter-spacing: 0.2px;

  @media (max-width: ${designTokens.breakpoints.tablet}) {
    font-size: ${designTokens.typography.fontSize.h3.tablet};
  }

  @media (max-width: ${designTokens.breakpoints.mobile}) {
    font-size: ${designTokens.typography.fontSize.h3.mobile};
  }
`;

/* Utility Heading - with decorative underline */
export const Heading = styled.h1`
  position: relative;
  font-family: ${designTokens.typography.fontFamily.primary};
  font-weight: 700;
  font-size: 36px;
  line-height: 1.2;
  color: ${({ fontColor }) =>
    fontColor
      ? designTokens.colors.neutral.dark
      : designTokens.colors.neutral.white};
  margin: ${(props) => props.margin || designTokens.spacing.lg}px 0;
  transition: transform ${designTokens.transitions.smooth};
  z-index: ${designTokens.zIndex.base};

  &:after {
    content: "";
    height: 6px;
    width: 102px;
    background: ${designTokens.colors.primary.main};
    position: absolute;
    top: 3rem;
    left: 16rem;
    border-radius: ${designTokens.borderRadius.small};

    @media (max-width: ${designTokens.breakpoints.tablet}) {
      top: 2rem;
      left: 8rem;
      width: 80px;
    }

    @media (max-width: ${designTokens.breakpoints.mobile}) {
      top: 1.5rem;
      left: 2rem;
      width: 60px;
    }
  }

  @media (max-width: ${designTokens.breakpoints.tablet}) {
    font-size: 28px;
  }

  @media (max-width: ${designTokens.breakpoints.mobile}) {
    font-size: 24px;
  }
`;
